export default __webpack_public_path__ + "static/media/Settings.f4efa95c.svg";